const baseURL = process.env.REACT_APP_backendURL
const mainDomain = process.env.REACT_APP_mainDomain
const SVG_PDF = process.env.REACT_APP_SVG_PDF

export const URLs = {
    USER: baseURL + "/auth/",
    CHECK_ADMIN: baseURL + "/Auth/checkAdmin/",
    ADMIN_PRODUCT: baseURL + "/Editor/TemplateProduct/",
    GET_ALL_PRODUCTS: baseURL + "/Editor/products/",
    GET_SINGLE_PRODUCT: baseURL + "/Editor/product/",
    USER_PRODUCT: baseURL + "/Editor/userproject/",
    UPLOAD_FILES: baseURL + "/Editor/SaveImage/",
    REMOVE_BG: baseURL + "/EasyBGurl/",
    ASK_SALLY: baseURL + "/sally/ask/",
    IMAGE_ENHANCEMENT: baseURL + "/enhancement/",
    ADD_GLOBAL_ASSET: baseURL + "/Editor/global_image_add/",
    GET_GLOBAL_ASSET: baseURL + "/Editor/public_asset/",
    GET_PDF: baseURL + "/cart/download_check/",
    SHARE_API: baseURL + "/Editor/createStory/",
}

export const RedirectURLs = {
    EDITOR_ECOM : mainDomain + '/editor/ecom-template-edit/',
    EDITOR_PROJECT : mainDomain + '/editor/project-template/edit/',
    REDIRECT_PROJECT : '/editor/project-template/edit/',
    REDIRECT_ECOM : '/editor/ecom-template-edit/',
}